// global-responsive-videos.js (V14.3)
document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('.responsive-video-container');

    videoContainers.forEach(container => {
        const videoElement = container.querySelector('video');
        if (!videoElement) return;

        const showPlayIconOnFail = true; 
        let coverElement = container.querySelector('.video-enhancer-cover');
        if (!coverElement) {
            coverElement = document.createElement('div');
            coverElement.className = 'video-enhancer-cover';
            if (showPlayIconOnFail) {
                coverElement.innerHTML = `
                    <div class="video-enhancer-play-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false" role="presentation">
                            <polygon points="30,20 30,80 80,50"/>
                        </svg>
                    </div>`;
            }
            const posterSrc = videoElement.getAttribute('poster');
            if (posterSrc) {
                coverElement.style.backgroundImage = `url('${posterSrc}')`;
            }
            videoElement.insertAdjacentElement('afterend', coverElement);
        }
        coverElement.style.display = 'none'; 

        let initialInteractionDone = false; // Tracks if the first main interaction has happened
        videoElement.controls = false; 

        // This specific handler is for the VERY FIRST tap on the video element itself,
        // typically after muted autoplay succeeded and hid the cover.
        function handleInitialVideoFirstTap(event) {
            event.preventDefault(); // Good to prevent default on this first managed interaction
            videoElement.muted = false;
            videoElement.controls = true;
            initialInteractionDone = true;
            if (videoElement.paused) { 
                videoElement.play().catch(e => console.warn('Play from initial video first tap failed', e));
            }
            if (coverElement) coverElement.style.display = 'none';
            videoElement.removeEventListener('click', handleInitialVideoFirstTap); // Self-remove
        }

        // Only add this specific listener if it's an autoplaying video
        if (videoElement.hasAttribute('autoplay')) {
            videoElement.addEventListener('click', handleInitialVideoFirstTap);
        } else {
            // If not autoplaying, the cover click is the main way to start,
            // or a direct click on video if no cover. A general click listener might be needed.
            // For now, assuming autoplay is always the intent for this enhancer.
        }
        
        videoElement.addEventListener('play', function () {
            if (coverElement) coverElement.classList.remove('is-visible'); // More robust hide
            // Controls are only added by the click handlers after initial interaction
        });

        if (coverElement) {
            coverElement.addEventListener('click', function (event) {
                event.preventDefault();
                videoElement.muted = false;
                videoElement.controls = true;
                initialInteractionDone = true;
                if (videoElement.paused) {
                    videoElement.play().catch(e => console.warn('Video play failed on cover interaction:', e));
                }
                if (coverElement) coverElement.style.display = 'none';
                // Since cover is clicked, the video's 'handleInitialVideoFirstTap' might not be needed anymore
                videoElement.removeEventListener('click', handleInitialVideoFirstTap);
            }, { once: true }); // Cover click is a one-time action to start
        }

        if (videoElement.hasAttribute('autoplay')) {
            const playPromise = videoElement.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    if (coverElement) coverElement.classList.remove('is-visible');
                }).catch(error => {
                    console.warn('Autoplay prevented for video:', videoElement.currentSrc || videoElement.src, error.name);
                    if (coverElement) {
                        coverElement.classList.add('is-visible');
                    }
                    // If autoplay fails, the 'handleInitialVideoFirstTap' is still on the video,
                    // and the cover click listener is also active.
                });
            } else {
                setTimeout(() => { /* ... (same timeout fallback) ... */ }, 150);
            }
        } else if (coverElement) {
             if (showPlayIconOnFail) coverElement.classList.add('is-visible');
        }
    });
});